
import { RecipeFeedback } from "@/types/recipe";
import { supabase } from "../../integrations/supabase/client";
import { handleServiceError, withErrorHandling } from "../utils/errorHandling";

export const feedbackQueryService = {
  /**
   * Fetches feedback for a specific recipe
   * @param recipeId The ID of the recipe to fetch feedback for
   * @returns Array of feedback items
   */
  getFeedbacksByRecipeId: withErrorHandling(
    async (recipeId: string): Promise<RecipeFeedback[]> => {
      // Get feedbacks directly, no need to join with profiles anymore
      const { data, error } = await supabase
        .from("recipe_feedbacks")
        .select("*")
        .eq("recipe_id", recipeId)
        .order("created_at", { ascending: false });

      if (error) {
        throw error;
      }

      // Convert from database format to RecipeFeedback type
      const feedbacks: RecipeFeedback[] = data.map((feedback) => ({
        id: feedback.id,
        recipeId: feedback.recipe_id,
        username: feedback.username,
        userId: feedback.user_id,
        firstName: feedback.first_name || feedback.username, // Use stored first_name or fallback to username
        comment: feedback.comment,
        rating: feedback.rating,
        createdAt: feedback.created_at,
      }));

      return feedbacks;
    },
    "Error fetching feedbacks"
  )
};
